import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as ThreeDotsIcon } from "assets/icons/ico_three_dots_green.svg";
import { ReactComponent as GarageIcon } from "assets/icons/ico_garage_black.svg";
import animSpinnerGreen from 'assets/animations/anim_spinner_green_40x40.json';
import Lottie from 'lottie-react';
import ItemContextMenu from "../../dashboard/tableItemContextMenu/itemContextMenu";
import { useMessages } from "context/messages";
import { getToken } from "context/auth";
import { openPassage } from "api/airPass";

const AirPassItem = ({ airPass }) => {
    const [showMenu, setShowMenu] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { showToast, showModal, hideModal } = useMessages();

    const handleOpenPassage = () => {
        setShowMenu(false);
        showModal(
            t('airPassTable.openPassageConfirmTitle'),
            t('airPassTable.openPassageConfirmDescription', { description: airPass.description, id: airPass.airPassExtId }),
            t('generic.yes'),
            async () => {
                hideModal();
                setIsLoading(true);
                try {
                    const token = await getToken();
                    const result = await openPassage(token, airPass.airPassExtId);

                    if (result.error) {
                        console.error(result);
                        showToast(t('airPassTable.openPassageErrorTitle'), t('airPassTable.openPassageErrorDescription'), 'error');
                    } else {
                        showToast(t('airPassTable.openPassageSuccessTitle'), t('airPassTable.openPassageSuccessDescription'), 'success');
                    }
                } catch (error) {
                    console.error(error);
                    showToast(t('airPassTable.openPassageErrorTitle'), t('airPassTable.openPassageErrorDescription'), 'error');
                }
                setIsLoading(false);
            },
            t('generic.no'),
            () => { hideModal(); }
        );
    };

    return (
        <tr className="h-16 border-b-[1px] border-airpark-gray-300">
            <td className="pl-6 whitespace-nowrap">
                {airPass.airPassExtId}
            </td>
            <td className="pl-6 whitespace-nowrap">
                {airPass.description}
            </td>
            <td className="pl-6 whitespace-nowrap">
                Lat {airPass.latitude}, Lng {airPass.longitude}
            </td>
            <td className="pl-6 whitespace-nowrap">
                {airPass.floor ?? ''}
            </td>
            <td className="border-l-[1px] border-airpark-gray-300 min-w-[72px] w-[72px] relative">
                {isLoading &&
                    <div className="justify-center items-center">
                        <Lottie className="h-6 w-full" animationData={animSpinnerGreen} loop={true} />
                    </div>
                }
                {!isLoading &&
                    <button className="flex h-16 w-full justify-center items-center" onClick={(e) => { e.preventDefault(); setShowMenu(!showMenu); }}>
                        <ThreeDotsIcon className="block" />
                    </button>
                }
                {showMenu &&
                    <ItemContextMenu
                        onCloseClick={() => { setShowMenu(false); }}
                        onEditClick={() => { navigate(`edit/${airPass.airPassExtId.toLowerCase()}`); }}>
                        <button className="flex items-center" onClick={(e) => { e.preventDefault(); handleOpenPassage(); }}>
                            <GarageIcon className="h-5 w-5" /><span className="ml-1">{t('airPassTable.openPassage')}</span>
                        </button>
                    </ItemContextMenu>
                }
            </td>
        </tr>
    )
}

export default AirPassItem;
